import React from "react";

import { ViaIcon } from "@/shared/components/ViaIcon";
import { catalogFor } from "@/shared/lib/interface-catalog";

import type { InterfaceType } from "@/shared/types";

/* In the composer's place on a conversation that came in through a channel.
   The agent answers it there, and replying from the dashboard is a later
   feature (tasks/interfaces/00-PLAN.md, decision 3), so the pane says so
   instead of offering a box whose every message would be refused. Drawn as
   the composer at rest, so it reads as the same slot. */
export default function ChannelNote({ via, agentName }: { via: InterfaceType; agentName: string }) {
  const channel = catalogFor(via)?.name ?? via;
  return (
    <div className="relative w-full max-w-[720px] mx-auto min-w-0">
      <div
        role="note"
        className="flex items-center gap-3 rounded-[16px] bg-[var(--surface)] p-3 ring-1 ring-[var(--hairline-strong)] shadow-[0_1px_2px_rgba(0,0,0,0.02),0_8px_24px_-16px_rgba(0,0,0,0.06)]"
      >
        <div className="w-9 h-9 shrink-0 rounded-[8px] bg-[var(--surface-sunk)] ring-1 ring-[var(--hairline)] flex items-center justify-center">
          <ViaIcon type={via} size={16} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[13px] font-medium text-[var(--text-primary)] tracking-[-0.005em]">
            This conversation happens on {channel}.
          </div>
          {/* Secondary, not tertiary: it is half of what the note says, and tertiary fails AA contrast at this size. */}
          <div className="text-[11.5px] text-[var(--text-secondary)] mt-[1px]">{agentName} answers there automatically.</div>
        </div>
      </div>
    </div>
  );
}
